var render = function render(_c,_vm){return _c('div',{staticClass:"card-array__wrapper"},[_c(_vm.$options.components.FunctionalFormulaArrayItems,{tag:"component",staticClass:"card-array",class:_vm.data.staticClass || '',attrs:{"row":_vm.props.row,"field":_vm.props.field,"value":_vm.props.value,"selected":true}},[(_vm.$options.methods.shouldFetchRow(_vm.props))?_c('div',{staticClass:"array-field__item",class:[
        _vm.data.staticClass,
        _vm.data.class,
        _vm.$options.methods.isFetchingRow(_vm.props)
          ? 'array-field__item--loading'
          : '',
      ]},[(_vm.$options.methods.isFetchingRow(_vm.props))?_c('div',{staticClass:"loading"}):_c('span',[_vm._v("...")])]):_vm._e(),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }